import { useState } from 'react';
import '../../styles/Home.css';
import STEAMnav from '../../nav/STEAM-Nav';

import Snowfall from "../Snowfall";

const STEAMDallas = () => {

  return (




    <div className="container">
      <STEAMnav ></STEAMnav>
      <div>
        <Snowfall ></Snowfall>
      </div>

      <div>
        <h3 className="center-align"><b>STEAM Olympics 2026 - Dallas, TX</b></h3>
        <h5 className="center-align">Location : Lords Indoor Sports, 2621 Summit Ave # 200, Plano, TX 75074</h5>
        <h5 className="center-align"><b className="cRed">Registrations close on 2/13/2026 at 5 pm.</b></h5>
        <h5 className="center-align"><b className="cBlue"><a href="/steam">(Click here for STEAM Olympics 2026 - Bloomington, IL)</a></b></h5>
      </div>

      <div><hr class="hr-line"></hr></div>

      <div className="row">

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/FBT.png" alt="" width="70%" className="rounded" /></p>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/IWU.png" alt="" width="70%" className="rounded" /></p>
        </div>

      </div>

      <div>
        <h5 className="justify c737373"><a href="/"><b>For A Better Tomorrow (FBT)</b></a> and <a href="https://www.iwu.edu/"><b>Illinois Wesleyan University (IWU)</b></a> <b>Proudly Present the 3<sup>rd</sup> Annual STEAM Olympics!. </b></h5>
      </div>

      <div>
        <h5 className="justify c737373">We're excited to welcome students in grades 1 through 12 for an inspiring four-day event focused on exploring the worlds of Science, Technology, Engineering, Arts, and Mathematics (STEAM)! This year we are expanding our footprint to Texas also apart from the Central Illinois region. </h5>
      </div>

      <div>
        <h5 className="justify c737373"> Mark your calendars </h5>
      </div>

      <div>
        <h5 className="justify c737373">Dallas Area : <b>February 14<sup>th</sup>  2026.</b></h5>
      </div>

      <div>
        <h5 className="justify c737373">The STEAM Olympics provides a unique opportunity for students of all ages to engage in hands-on experiences, learning, and friendly competition across a variety of STEAM disciplines. Through this event, young thinkers and problem-solvers can delve into subjects that foster creativity, curiosity, and innovation.</h5>
      </div>

      <p >&nbsp;</p>
      <div><hr class="hr-line"></hr></div>

      <div className="row">

        <div className="col-sm">

          <h4 className="center-align"><b >Event Purpose & Impact</b></h4>
          <h5 className="justify c737373"><i >STEAM Olympics is more than a competition it's a collaborative effort between FBT and IWU to inspire the next generation while supporting impactful initiatives. Proceeds from this event will help fund scholarships and support grants for projects on both local and global scales. In particular, FBT will award financial need-based scholarships to IWU students involved in the Council of Inclusion and Awareness (CIA), promoting social justice and community engagement.</i></h5>
        </div>

      </div>

      <p >&nbsp;</p>
      <div><hr class="hr-line"></hr></div>

      <div className="row">

        <div className="col-sm">

          <h4 className="center-align"><b >Event Schedule & Activities</b></h4>
          <h5 className="justify c737373"><i >Below, you ll find the details for each contest, including eligibility criteria, dates, times, and enrollment fees. To learn more about each activity, simply click on the activity name.</i></h5>
          <h5 className="center-align"><b className="cRed">Note : Registrations close on 2/13/2026 at 5 pm.</b></h5>
        </div>

      </div>

      <div className="row">

        <table className="table table-bordered">

          <thead>

            <tr>
              <th scope="col" className="center-align">Activity</th>
              <th scope="col" className="center-align">Grades*</th>
              <th scope="col" className="center-align">Date/Time</th>
              <th scope="col" className="center-align">Room</th>
              <th scope="col" className="center-align">Enrollment Fees</th>
            </tr>

          </thead>

          <tbody>

            <tr>
              <td rowspan="3" className="center-align align-middle"><a href="/steam/event/math">Math Test</a></td>
              <td className="center-align">1, 2 & 3</td>
              <td className="center-align">Saturday, Feb 14<sup>th</sup><br />
                1:30 pm - 3:00 pm</td>
              <td className="center-align">Lords Indoor Sports</td>
              <td rowspan="3" className="center-align align-middle">$25 (before 01/10/2026 5:00PM)<br />
                $30 (After 01/10/2026 5:00PM)</td>
            </tr>

            <tr>
              <td className="center-align">4,5</td>
              <td className="center-align">Saturday, Feb 14<sup>th</sup><br />
                1:30 pm - 3:00 pm</td>
              <td className="center-align">Lords Indoor Sports</td>
            </tr>

            <tr>
              <td className="center-align">6, 7 & 8</td>
              <td className="center-align">Saturday, Feb 14<sup>th</sup><br />
                1:30 pm - 3:00 pm</td>
              <td className="center-align">Lords Indoor Sports</td>
            </tr>

            <tr>
              <td rowspan="3" className="center-align align-middle"><a href="/steam/event/science-test">Science Test</a></td>
              <td className="center-align">1, 2 & 3</td>
              <td className="center-align">Saturday, Feb 14<sup>th</sup><br />
                11:30 am - 1:00 pm</td>
              <td className="center-align">Lords Indoor Sports</td>
              <td rowspan="3" className="center-align align-middle">$25 (before 01/10/2026 5:00PM)<br />
                $30 (After 01/10/2026 5:00PM)</td>
            </tr>

            <tr>
              <td className="center-align">4,5</td>
              <td className="center-align">Saturday, Feb 14<sup>th</sup><br />
                11:30 am - 1:00 pm</td>
              <td className="center-align">Lords Indoor Sports</td>
            </tr>

            <tr>
              <td className="center-align">6, 7 & 8</td>
              <td className="center-align">Saturday, Feb 14<sup>th</sup><br />
                11:30 am - 1:00 pm</td>
              <td className="center-align">Lords Indoor Sports</td>
            </tr>

          </tbody>

        </table>

        <h5 className="justify c737373"><i ><b>Note:</b> As a volunteer-led fundraising event, we are unable to provide refunds for registration fees. Your support helps make the STEAM Olympics possible and allows us to offer valuable opportunities and financial assistance to students. Thank you for your understanding and commitment to our mission!</i></h5>
      </div>

      <p >&nbsp;</p>
      <div><hr class="hr-line"></hr></div>

      <div className="row">

        <div className="col-sm">

          <h4 className="center-align"><b >Schedule</b></h4>
        </div>

      </div>

      <div>
        <h2 class="center-align"><b ></b></h2>
        <p class="center-align"><img src="/images/steam/2026/ScheduleDallas.png" alt="" width="100%" border="2" className="rounded" /></p>
      </div>

      <div><hr class="hr-line"></hr></div>

      <div className="row">

        <div className="col-sm">

          <h4 className="center-align"><b >Award Ceremony</b></h4>
          <h5 className="justify c737373"><i >Will be updated soon.</i></h5>
        </div>

      </div>

      <p >&nbsp;</p>
      <div><hr class="hr-line"></hr></div>

      <div className="row">

        <div className="col-sm">

          <h4 className="center-align"><b >Share the Excitement!</b></h4>
          <h5 className="center-align"><i >Help us spread the word about STEAM Olympics by sharing our event flyers <a href="/flyer/steam2026">Bloomington Flyer</a> and <a href="/flyer/steam2026-dallas">Dallas Flyer.</a></i></h5>
        </div>

      </div>

      <p >&nbsp;</p>
      <div className="row">

        <div className="col-sm">

          <h4 className="center-align"><b >Ready to Register?</b></h4>
          <h5 className="center-align"><i >Sign up now to secure your spot in one or more activities. Early registration discounts apply! </i></h5>
          <h5 className="center-align"><a type="button" class="btn btn-primary btn-lg" href="https://docs.google.com/forms/d/e/1FAIpQLSfqYFZ7xkHWIbRwV-We6UTnNh-2hRBsDMf1OEr2i0p6Gu4oHA/viewform">Register here</a></h5>
          <p >&nbsp;</p>
          <h5 className="center-align"><i >Join us for a fantastic celebration of creativity, learning, and innovation in STEAM!</i></h5>
        </div>

      </div>

      <div className="row">

        <div className="col-sm">

        </div>

        <div className="col-sm">
          <p className="center-align"><a href="https://docs.google.com/document/d/1ODoL0oz9SP1L-Cbnf-spTl7RF2Rbn4n60yIupvq53D0/edit?tab=t.0"> <img src="/images/steam/FAQ.png" alt="" width="100" height="100" class="rounded" /> </a></p>
          <h5 className="center-align"><a href="https://docs.google.com/document/d/1ODoL0oz9SP1L-Cbnf-spTl7RF2Rbn4n60yIupvq53D0/edit?tab=t.0">Frequently asked questions.</a></h5>
        </div>

        <div className="col-sm">

        </div>

      </div>

      <div><hr class="hr-line"></hr></div>

    </div>




  );
}
export default STEAMDallas;
